
import * as GameProto from "./proto/proto_bullbull_game";
import * as RoomProto from "./proto/proto_bullbull_room";

const {ccclass,property } = cc._decorator;

@ccclass
export default class NetMsgDataBullBullGame{

    /**
     * 发送命令名|发送结构体|收包命令|收包结构体|协议类型:1为登录服，2为麻将游戏服，3为Skynet扑克服
     * 
     */     
    
    
    /**
     * 同步房间信息
     */
    public static readonly SyncRoomInfo : any[] = [null,null,
                                              "Room.SynchronizeBroadcast",RoomProto.BullBullRoom.SynchronizeBroadcast,3];

    public static readonly EnterRsp : any[] = [null,null,
                                                "Room.EnterRsp",RoomProto.BullBullRoom.EnterRsp,3];        

    //座位自定义信息变化广播                                            
    public static readonly CustomInfo : any[] = [null,null,
                                                "Room.CustomInfoChangeBroadcast",RoomProto.BullBullRoom.CustomInfoChangeBroadcast,3];

    /**
     * 离开房间
     */
    public static readonly LeaveRoom : any[] = ["Room.LeaveReq",RoomProto.BullBullRoom.LeaveReq,
                                                "Room.LeaveRsp",RoomProto.BullBullRoom.LeaveRsp,3];

    /**
     * 房间信息
     */
    public static readonly RoomInfo : any[] = [null,null,
                                              "Room.RoomInfo",RoomProto.BullBullRoom.RoomInfo,3];

    /**
     *  座位信息
     */                                                
    public static readonly SetatInfo : any[] = [null,null,
                                                "Room.SeatInfo",RoomProto.BullBullRoom.SeatInfo,3]

    /**
     * 金币扣除
     */
    public static readonly OneShotSettleNotify : any[] = [null,null,
                                                        "Room.OneShotSettleNotify",RoomProto.BullBullRoom.OneShotSettleNotify,3];                                                
   
    /**
     * 新进入房间玩家广播
     */                                                
    public static readonly EnterBroadcast  : any[] = [null,null,
                                                    "Room.EnterBroadcast",RoomProto.BullBullRoom.EnterBroadcast,3];                                              


    public static readonly ReadyInfo : any[] = ["Room.ReadyReq",RoomProto.BullBullRoom.ReadyReq,
                                               "Room.ReadyRsp",RoomProto.BullBullRoom.ReadyRsp,3];          
       
    public static readonly ReadyBroadcast: any[] = [null,null,
                                                "Room.ReadyBroadcast",RoomProto.BullBullRoom.ReadyBroadcast,3];                                                                                              
                                               
                                     
        
                                                

    /**
     * 踢人广播
     */
    public static readonly KickPlayerBroadcast : any[] = [null,null,
                                                        "Room.KickPlayerBroadcast",RoomProto.BullBullRoom.KickPlayerBroadcast,3];                                               
    
                                               
    /**
     * 开始游戏广播 
     * */                                               
    public static readonly StartBroadcast : any[] = [null,null,
                                                    "Room.StartBroadcast",RoomProto.BullBullRoom.StartBroadcast,3];
                    
    public static readonly LeaveBroadcast : any[] = [null,null,
                                                        "Room.LeaveBroadcast",RoomProto.BullBullRoom.LeaveBroadcast,3];                                                                                                       

    public static readonly SynExpireBroadcast : any[] = [null,null,
                                                        "Room.SynExpireBroadcast",RoomProto.BullBullRoom.SynExpireBroadcast,3]                                                

    public static readonly ResetBroadcast : any[] = [null,null,
                                                        "Room.ResetBroadcast",RoomProto.BullBullRoom.ResetBroadcast,3]                                                                                                        
               
    public static readonly ReconnBroadcast : any[] = [null,null,
                                                            "Room.ReconnBroadcast",RoomProto.BullBullRoom.ReconnBroadcast,3];                                                        
                                                        
    /**** Game ****/          
    
    
    public static readonly TimeoutNotify : any[] = [null,null,
                                                    "Game.TimeoutNotify",GameProto.BullBullGame.TimeoutNotify,3]      

    /**
     * 发牌
     */
    public static readonly DealPoker : any[] = [null,null,
                                                "Game.DealPokerBroadcast",GameProto.BullBullGame.DealPokerBroadcast,3];
    
    /**
     * 比牌
     */                                                
    public static readonly ComputePoker : any[] = ["Game.ComputePokerReq",GameProto.BullBullGame.ComputePokerReq,
                                                    "Game.ComputePokerRsp",GameProto.BullBullGame.ComputePokerRsp,3]                                                

                                                        
                                                    
    /**
     *  比牌广播
     */                                                
    public static readonly ComputePokerBroadcast : any[] = [null,null,
                                                "Game.ComputePokerBroadcast",GameProto.BullBullGame.ComputePokerBroadcast,3];                                                    

    public static readonly BetInfo : any[] = ["Game.BetReq",GameProto.BullBullGame.BetReq,
                                             "Game.BetRsp",GameProto.BullBullGame.BetRsp,3]                                                
    
    public static readonly BetTypeBroadcast : any[] = [null,null,
                                                      "Game.BetTypeBroadcast",GameProto.BullBullGame.BetTypeBroadcast,3];                                             

    public static readonly SettleAccountsBroadcast : any[] = [null,null,
                                                        "Game.SettleAccountsBroadcast",GameProto.BullBullGame.SettleAccountsBroadcast,3];                                                                                                   

    public static readonly BetBroadcast : any[] = [null,null,
                                                   "Game.BetBroadcast",GameProto.BullBullGame.BetBroadcast,3];                                                        


    public static readonly ScrambleBanker : any[] = ["Game.ScrambleBankerReq",GameProto.BullBullGame.ScrambleBankerReq,
                                                    "Game.ScrambleBankerRsp",GameProto.BullBullGame.ScrambleBankerRsp,3];                                                        

    //抢庄广播                                                    
    public static readonly ScrambleBankerBroadcast : any = [null,null,
                                                            "Game.ScrambleBankerBroadcast",GameProto.BullBullGame.ScrambleBankerBroadcast,3];
                                                    
    /**
     * 参与抢庄的玩家
     */                                                        
    public static readonly SetBankerBroadcast : any[] = [null,null,
                                                        "Game.SetBankerBroadcast",GameProto.BullBullGame.SetBankerBroadcast,3];                                                        

    /**
     * 抢庄通知
     */
    public static readonly ScrmbleBankerNotify : any[] = [null,null,
                                                            "Game.ScrmbleBankerNotify",GameProto.BullBullGame.ScrmbleBankerNotify,3];                                                        

    public static readonly AgoSettleAccountsBroadcast : any = [null,null,
                                                                "Game.AgoSettleAccountsBroadcast",GameProto.BullBullGame.AgoSettleAccountsBroadcast,3];                                                            

    public static readonly Ack : any[] = ["Game.AckReq",GameProto.BullBullGame.AckReq,null,null,3];    

}